import { convertToInlineStyle, getReactProps } from '@m2h/common/utils/styleUtils';

interface PayData {
  code?: number;
  payMethod?: string;
}

export interface PayComponentCallbackEvent {
  payAction: string; // 对应的业务场景
  payData?: PayData; // 对应业务场景的业务数据，不同业务场景的业务数据格式不同
}

const RENDER_SUCCESS = 10000200; // 渲染成功
const INIT_PAYMENT = 'pay_component_finished'; // 支付组件初始化

export default class PayComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this; // timeout里使用this有点问题可能回到window

    setTimeout(() => {
      const reactProps = getReactProps(self) || {};
      if (reactProps) {
        if (reactProps.onPayComponentCallback) {
          const payEvent: PayComponentCallbackEvent = {
            payAction: INIT_PAYMENT, // 对应的业务场景
            payData: {
              code: RENDER_SUCCESS,
              payMethod: '',
            }, // 对应业务场景的业务数据，不同业务场景的业务数据格式不同
          };
          reactProps.onPayComponentCallback(payEvent);
        }
        // react某些动态样式转换，在初始化时还没有值
        if (reactProps.style) {
          const reactPropsStyleStr = convertToInlineStyle(reactProps.style);
          self.style.cssText = `${self.style.cssText}${reactPropsStyleStr}`;
        }
      }
    }, 0);
  }

  static get observedAttributes() {
    return [];
  }
  attributeChangedCallback() {
  }

  disconnectedCallback() {
  }
}
